// api/auth.ts
import axios from "axios";
import { endpointUrl } from "../endpoints";

// Register a new user
export const registerVendor = async (userData: {
  name: string;
  username: string;
  email: string;
  password: string;
  password_confirmation: string;
  role: string;
}) => {
  try {
    const response = await axios.post(endpointUrl.registerVendor, userData);
    return response.data; // Return the response data
  } catch (error: any) {
    console.error("API Error:", error.response?.data || error.message);
    throw error; // Re-throw the error for React Query to handle
  }
};
